import { Trans } from "react-i18next";
import React, { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate, NavLink } from "react-router-dom";
import { IPublicClientApplication } from "@azure/msal-browser";

import { loginRequest } from "../authConfig";

const SignInManager: React.FC = () => {
  const { instance } = useMsal();
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleLogin = (instance: IPublicClientApplication) => {
    loginRequest.loginHint = email;
    instance.loginRedirect(loginRequest).catch((e) => {
      console.error(e);
    });
  };

  useEffect(() => {
    const user = localStorage.getItem("token");
    const provider = localStorage.getItem("auth-provider");
    if (user && provider === "azure-sso") {
      navigate("/event-monitoring");
    }
  }, [navigate]);

  return (
    <section className="lg:px-16 font-Poppins">
      <div className="px-5 lg:px-0 py-10">
        <img
          src="/images/logo-light.png"
          className="w-[164px] h-auto"
          alt="logo"
        />
      </div>
      <h2 className="md:px-24 px-5 py-5 text-[#1E408E] font-bold text-4xl leading-10">
        <Trans i18nKey="Welcome to the Quality Monitoring Portal">
          Welcome to the Quality Monitoring Portal
        </Trans>
        .
      </h2>
      <div className="grid lg:grid-cols-2 grid-cols-1">
        <div className="text-[#1E408E] md:px-24 px-5 py-5">
          <div className="border-2 border-gray-500">
            <div className="p-5">
              <div>
                <img
                  src="/images/logo-light.png"
                  className="w-[164px] h-auto"
                  alt="logo"
                />
              </div>
              <div className="mt-3 text-left sm:mt-5">
                <h3 className="text-lg font-medium leading-6 mb-2 text-gray-900">
                  <Trans i18nKey="Login">Login</Trans>
                </h3>
                <input
                  type="text"
                  placeholder="E-mail, telephone ou identifiant skype"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full border-b border-gray-500 focus:ring-transparent bg-white"
                />
                <div className="mt-2">
                  <NavLink to={"/"} className="text-sm text-blue-500">
                    <Trans i18nKey="Your account is not accessible">
                      Your account is not accessible
                    </Trans>
                  </NavLink>
                </div>
              </div>
              <div className="flex gap-1 justify-end mt-5 sm:mt-6">
                <button
                  type="button"
                  className="block justify-center border border-transparent bg-gray-500 px-4 py-2 text-base font-medium text-white sm:text-sm"
                >
                  <Trans i18nKey="Return">Return</Trans>
                </button>
                <button
                  type="button"
                  className="block justify-center border border-transparent bg-[#1E408E] px-4 py-2 text-base font-medium text-white sm:text-sm"
                  onClick={() => {
                    handleLogin(instance);
                  }}
                >
                  <Trans i18nKey="Next">Next</Trans>
                </button>
              </div>
            </div>
            <div className="w-full grid justify-center bg-gray-300 p-5">
              <p className="text-black">
                <Trans i18nKey="welcome_to_family">
                  Welcome to Babilou Family. Please sign in to your{" "}
                  <strong>email address</strong> and click on next
                </Trans>
              </p>
            </div>
            <div className="bg-gray-500 bg-opacity-60 w-full h-10"></div>
            <div className="flex gap-3 px-8 py-2 text-gray-900">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="2rem"
                height="2rem"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 16 16"
              >
                <g transform="rotate(45 8 8)">
                  <g fill="currentColor">
                    <path d="M0 8a4 4 0 0 1 7.465-2H14a.5.5 0 0 1 .354.146l1.5 1.5a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0L13 9.207l-.646.647a.5.5 0 0 1-.708 0L11 9.207l-.646.647a.5.5 0 0 1-.708 0L9 9.207l-.646.647A.5.5 0 0 1 8 10h-.535A4 4 0 0 1 0 8zm4-3a3 3 0 1 0 2.712 4.285A.5.5 0 0 1 7.163 9h.63l.853-.854a.5.5 0 0 1 .708 0l.646.647l.646-.647a.5.5 0 0 1 .708 0l.646.647l.646-.647a.5.5 0 0 1 .708 0l.646.647l.793-.793l-1-1h-6.63a.5.5 0 0 1-.451-.285A3 3 0 0 0 4 5z" />
                    <path d="M4 8a1 1 0 1 1-2 0a1 1 0 0 1 2 0z" />
                  </g>
                </g>
              </svg>
              <p>
                <Trans i18nKey="Login Options">Login Options</Trans>
              </p>
            </div>
          </div>
        </div>
        <div className="lg:grid justify-center hidden">
          <img
            src="/images/LoginPage.png"
            alt="babies"
            className="max-w-full h-auto"
          />
        </div>
      </div>
    </section>
  );
};

export default SignInManager;
